import type { SxProps, Theme } from '@mui/material/styles';
import { APP_FONT_FAMILY } from './fonts';

/** Title on setup / form coachmarks — matches platform weight, slightly under body. */
export const COACHMARK_TITLE_SX: SxProps<Theme> = {
  fontFamily: APP_FONT_FAMILY,
  fontSize: '0.9375rem',
  fontWeight: 600,
  lineHeight: 1.35,
  letterSpacing: 0,
};

/** Supporting line under the title. */
export const COACHMARK_SUBTITLE_SX: SxProps<Theme> = {
  fontFamily: APP_FONT_FAMILY,
  fontSize: '0.8125rem',
  fontWeight: 400,
  lineHeight: 1.45,
  letterSpacing: 0,
};
